/**
 * Get href for page.
 *
 * @returns {string} - Page href.
 */
export const getDocumentHref = () => document.location.href;

/**
 * Get title for page.
 *
 * @returns {string} - Page title.
 */
export const getDocumentTitle = () => document.title;
